import { render, staticRenderFns } from "./Logo.vue?vue&type=template&id=5c4e4a1e&scoped=true"
var script = {}
import style0 from "./Logo.vue?vue&type=style&index=0&id=5c4e4a1e&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5c4e4a1e",
  null
  
)

export default component.exports